/**
 * English strings for the `ai` namespace. The source of truth: French is
 * typed against this file. See `apps/web/src/i18n/README.md`.
 */
const ai = {
  chat: {
    untitled: "Untitled",
    newConversation: "New conversation",
    emptyTitle: "Ask about this meeting",
    emptyBody: "Answers cite the moments they came from — click one to jump there.",
    placeholder: "Ask about this meeting…",
    deleteQuestion: "Delete this question and its answer",
    deleteAnswer: "Delete this answer",
    couldNotOpen: "That conversation could not be opened.",
    unavailable: "Chat is unavailable right now.",
    somethingWrong: "Something went wrong.",
    when: {
      justNow: "just now",
      minutesAgo: "{{count}}m ago",
      hoursAgo: "{{count}}h ago",
      daysAgo: "{{count}}d ago",
    },
    history: {
      title: "Conversations",
      close: "Close history",
      empty: "No conversations yet. Ask something and it is saved here, named after what you asked.",
      saveName: "Save name",
      confirmDelete: "Delete this?",
      deleteConversation: "Delete conversation",
    },
  },
  summary: {
    title: "Summary",
    askedBy: "· asked for by {{name}}",
    generating: "Generating",
    regenerate: "Regenerate",
    generate: "Generate summary",
    noTranscript:
      "There is no transcript for this recording yet, so there is nothing to summarise.",
    none: "No summary yet. Generating one reads the whole transcript with your workspace's model and pulls out what was decided, what people took on, and what was left unanswered. Everyone in the workspace sees the result.",
    failed: "The summary could not be generated.",
    reading: "Reading the transcript. This usually takes under a minute.",
    couldNotStart: "Could not start generation.",
    tabs: {
      overview: "Overview",
      decisions: "Decisions",
      actions: "Actions",
      questions: "Open questions",
    },
    keyPoints: "Key points",
    noDecisions: "Nothing was settled in this meeting.",
    noActions: "Nobody took anything on.",
    unassigned: "Unassigned",
    noQuestions: "Nothing was left hanging.",
    askedByPerson: "asked by {{name}}",
    jumpToSpeaker: "Jump to {{speaker}} at {{time}}",
    jumpTo: "Jump to {{time}}",
  },
  export: {
    title: "Export",
    downloadOriginal: "Download the original",
    downloadOriginalDetail: "The video as stored, no subtitles. Instant.",
    burnedLegend: "Export with subtitles burned in",
    noTranscript:
      "This recording has no transcript yet, so there are no subtitles to burn. Transcribe it first from the transcript panel.",
    translationsFailed: "Couldn't load the translations.",
    originalLanguage: "Original language",
    originalDetail: "The transcript as spoken.",
    languageLabel: "{{name}} · {{native}}",
    translationReady: "Translation ready.",
    translating: "Translating…",
    translationFailed: "Translation failed.",
    cancelTitle: "Stop this translation — billing stops at the next batch",
    retryTitle: "Translate the transcript with the workspace's AI model",
    addLanguage: "Add a language…",
    translate: "Translate",
    translateFirst: "Translate this language first, then export.",
    exportTitle: "Re-encodes the video with the chosen subtitles burned in",
    exportVideo: "Export video",
    exportsFailed: "Couldn't load past exports.",
    exports: "Exports",
    encoding: "Encoding…",
    translationCancelled: "Translation cancelled.",
    exportStarted: "Export started — it appears below when ready.",
  },
  search: {
    placeholder: "Search across every meeting…",
    hint: "Try a phrase you remember hearing. Quoted phrases work, and so does <mono>-word</mono> to exclude one.",
    failed: "Search didn't work",
    emptyTitle: "Nothing found",
    emptyBody: "No meeting mentions that. Try fewer or different words.",
  },
} as const;

export default ai;
